<template>
    <div :style="getContainerStyle(data?.style)" class="dynamic-block-container">
      <!-- Header -->
      <div v-if="parsedHeader" v-html="parsedHeader"></div>
      
      <!-- Dynamisch wiederholter Children-Bereich -->
    <div v-if="placeholdersEnabled">
      <div v-for="(item, index) in dynamicItems" :key="index">
        <div v-html="parsedChildren(index)"></div>
      </div>
    </div>
    <div v-else>
        <div v-if="parsedContent" v-html="parsedContent"></div>
    </div>
      <!-- Footer -->
      <div v-if="parsedFooter" v-html="parsedFooter"></div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import DOMPurify from 'dompurify';
  //import { getXmlNodesByPath } from '@/utils/getXmlNodesByPath';
  import { replacePlaceholders } from '@/utils/replacePlaceholders';
  
  export default {
    name: 'DynamicBlock',
    props: {
      data: Object,
    },
    computed: {
      ...mapState(['placeholdersEnabled', 'emailData', 'xPathPlaceholders']),
      // Ermittelt alle XML-Knoten anhand des dynamischen XPath
      dynamicItems() {
        const item = this.xPathPlaceholders.find(placeholder => placeholder.placeholder == this.data.props.dynamicXPath )
        return item.value || ['test', 'test'];
      },
      parsedHeader() {
        let header = this.data?.props?.header || '';
        return DOMPurify.sanitize(header, { ADD_ATTR: ['target', 'rel'] });
      },
      parsedFooter() {
        let footer = this.data?.props?.footer || '';
        return DOMPurify.sanitize(footer, { ADD_ATTR: ['target', 'rel'] });
      },
      parsedContent() {
        let content = this.data?.props?.children || '';
        content = content.replace(/\[\[(.*?)\]\]/g, (match, p1) => {
            return `<span style="color: #05bbef">
                      <span class="material-symbols-outlined" style="font-size: 12px">bolt</span>
                      ${p1}
                      <span class="material-symbols-outlined" style="font-size: 12px">bolt</span>
                    </span>`;
          });
          content = content.replace(/\%\%(.*?)\%\%/g, (match, p1) => {
            return `<span style="color: red">
                      <span class="material-symbols-outlined" style="font-size: 12px">rule</span>
                      ${p1}
                      <span class="material-symbols-outlined" style="font-size: 12px">rule</span>
                    </span>`;
          });
        return DOMPurify.sanitize(content, { ADD_ATTR: ['target', 'rel'] });
      }
    },
    methods: {
      parsedChildren(index) {
        let childrenHtml = this.data?.props?.children || '';
         /*  const regex = new RegExp(`\\[\\[${this.xPathPlaceholders.placeholder}\\]\\]`, 'g');
          const value = this.xPathPlaceholders.value */
          childrenHtml = replacePlaceholders(childrenHtml, true, null, index)
        return childrenHtml;
      },
      // Gibt einen Containerstil zurück – analog zur getTextStyle-Methode in TextBlock.
      getContainerStyle(style) {
        const defaultFontSize = this.emailData.root.data.fontSize;
        const fontSize = style?.fontSize ? `${style.fontSize}px` : `${defaultFontSize}px`;
        const padding = style?.padding || { top: 0, bottom: 0, left: 0, right: 0 };
        return {
          color: style?.color || null,
          backgroundColor: style?.backgroundColor || null,
          textAlign: style?.textAlign || 'left',
          fontSize: fontSize,
          fontFamily: style?.fontFamily || 'inherit',
          padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
        };
      },
    },
  };
  </script>

  <style lang="scss" scoped>
  /* Basic editor styles */
  
  ::v-deep table {
  border-collapse: collapse;
  margin: 0;
  overflow: hidden;
  table-layout: fixed;
  width: 100%;
}

::v-deep td,
::v-deep th {
  border: 1px solid black;
  box-sizing: border-box;
  min-width: 1em;
  padding: 6px 8px;
  position: relative;
  vertical-align: top;
}

::v-deep td > *,
::v-deep th > * {
  margin-bottom: 0;
}

::v-deep th {
  text-align: left;
  color: green;
}



  </style>

  